import { isSameId, getAreaId, getCardAreaId, getSortedCards, } from "../../helpers";
export default function (store, { id, before, columnId, rowId }) {
    const state = store.getState();
    const columnKey = state.columnKey;
    const rowKey = state.rowKey;
    const cardIndex = state.cards.findIndex(c => isSameId(c.id, id));
    if (cardIndex < 0) {
        return;
    }
    if (!state.cardsMap[getAreaId(columnId, rowId)]) {
        return;
    }
    if (isSameId(id, before)) {
        return;
    }
    const card = state.cards[cardIndex];
    const isInSameArea = getAreaId(columnId, rowId) === getCardAreaId(card, columnKey, rowKey);
    const isInSameColumn = isSameId(columnId, card[columnKey]);
    const areaMeta = store.getState().areasMeta[getAreaId(columnId, rowId)];
    if (areaMeta.noFreeSpace && !isInSameColumn && !isInSameArea) {
        return;
    }
    const movedCard = state.cards.splice(cardIndex, 1)[0];
    const originalCard = { ...movedCard };
    const cardArea = state.cardsMap[getCardAreaId(originalCard, state.columnKey, state.rowKey)] || [];
    const movedCardIndex = cardArea.findIndex(c => isSameId(c.id, id)) || 0;
    const afterCard = cardArea[movedCardIndex + 1] || {};
    movedCard[columnKey] = columnId;
    // [todo] if rowKey is present but rowId not defined add first row key
    if (rowKey && rowId) {
        movedCard[rowKey] = rowId;
    }
    if (!before) {
        state.cards.push(movedCard);
    }
    else {
        const overCardIndex = state.cards.findIndex(c => isSameId(c.id, before));
        state.cards.splice(overCardIndex, 0, movedCard);
    }
    if (state.sort) {
        state.cards = getSortedCards({ ...state, cards: state.cards }, store.sortRule);
    }
    store.setState({ cards: state.cards });
    return () => {
        const columnId = originalCard[columnKey];
        const rowId = rowKey && originalCard[rowKey];
        store.in.exec("move-card", {
            id,
            before: afterCard.id,
            columnId,
            rowId,
            $meta: { skipHistory: true },
        });
    };
}
//# sourceMappingURL=move.js.map